import { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from 'utils/images';
import { SIDE_MENU_LIST } from './icons';
import { useLocation } from 'react-router-dom';
import { cookieDecryption } from 'utils';
import useAdminUsers from 'hooks/store/admin-users/useAdminUsers';
import useCurrentUserLogo from 'hooks/query/common/useCurrentUserLogo';

type SideMenuProps = {};

function SideMenu({}: SideMenuProps) {
  const location = useLocation();
  const [, pathname] = location.pathname.split('/');
  const auth = cookieDecryption('user');
  // IA-1077: prefer the freshly signed logo; fall back to the (short-lived) cookie value
  // until it loads, then to the bundled default logo.
  const { logo: freshLogo } = useCurrentUserLogo();
  // A partner logo that fails to load (expired or unsigned URL) falls back to the default logo;
  // a different URL arriving later is still tried.
  const [failedLogo, setFailedLogo] = useState<string | null>(null);
  const partnerLogo = freshLogo || auth?.logo;
  const logoSrc = partnerLogo && partnerLogo !== failedLogo ? partnerLogo : Logo;

  const navigate = useNavigate();

  const pageChanger = (title: string, path: string) => {
    navigate(path);
  };
  const handleContextMenu = (e: any) => {
    // Prevent the default context menu behavior
    e.preventDefault();
  };
  const { setState } = useAdminUsers();

  return (
    <div className="app">
      <p className="logo-box mb-50">
        <div
          style={{
            height: '54px',
            width: '178px',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '50px',
          }}>
          <img
            src={logoSrc}
            alt="logo"
            style={{ width: '178px', height: '54px' }}
            onError={() => partnerLogo && setFailedLogo(partnerLogo)}
          />
        </div>
      </p>
      <div className="dashboard-menu">
        <div className="menu-wrapper pt_10">
          <div className="menu">
            {SIDE_MENU_LIST.map(
              ({ title, icon: Icon, path, allowedRoles }) =>
                allowedRoles.includes(auth?.role) && (
                  <div
                    className={`cursor_pointer menu_list ${(path === pathname || path.includes(pathname) || pathname.includes(path)) && 'active'}`}
                    onClick={() => {
                      setState({ addClass: false });
                      pageChanger(title, path);
                    }}
                    onContextMenu={handleContextMenu}>
                    <div className="flex-center menu_name_icon">
                      <span className="menu-icon">
                        <Icon />
                      </span>
                      <span className="menu-text">{title}</span>
                    </div>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(SideMenu);
